export default "__VITE_ASSET__peu7yhL7__"